module.exports = __webpack_public_path__ + "img/8.13b92e63.png";